import PageLayout from '@frolight/components/PageLayout';
import Panel from '@frolight/components/Panel';
import usePageTitle from '@frolight/hooks/usePageTitle';

import GatewayListItem from './components/GatewayListItem';

import usePageData from './hooks/usePageData';
import useLocalizedFormattedText from '@frolight/hooks/useLocalizedFormattedText';

const Dashboard = () => {
  const { lftext } = useLocalizedFormattedText();

  usePageTitle(lftext('pages.dashboard.page_title'));

  const { loading: pageDataLoading, error: pageDataError, data: pageData } = usePageData();

  const renderError = () => {
    let errorMessage = '';

    switch (pageDataError) {
      case 'NO_ORGANISATION_MEMBERSHIPS':
        errorMessage = (
          <p>
            {lftext('pages.dashboard.errors.no_organisation_memberships')}
          </p>
        );
        break;
      default:
        errorMessage = (
          <>
              {lftext('pages.dashboard.errors.default_error')}
          </>
        );
        break;
    }

    return (
      <div className="feedback_message  feedback_message--error">
        { errorMessage }
      </div>
    );
  }

  return (
    <PageLayout>
      <h1 className="descriptive_page_title">{lftext('pages.dashboard.title')}</h1>
      {
        pageDataLoading &&
        <Panel hasPadding={ false } size="huge">
          <div className="loader">
            <p>{lftext('common.loading')}</p>
          </div>
        </Panel>
      }
      {
        !pageDataLoading &&
        pageDataError &&
        renderError()
      }
      {
        !pageDataLoading &&
        !pageDataError &&
        (pageData.organisations.length || pageData.unregisteredGateways.length) &&
        <div className="content_layout">
          {
            pageData.organisations.map((organisation) =>
              <Panel size="huge" title={ organisation.name } key={ `org-${organisation.id}` }>
                {
                  organisation.gateways.length ? (
                    <ul className="list">
                      {
                        organisation.gateways.map(gateway => 
                          <GatewayListItem
                            key={ `gateway-${gateway.id}` }
                            gateway={ gateway }
                          />
                        )
                      }
                    </ul>
                  ) : (
                    null
                  )
                }
              </Panel>
            )
          }
          {
            pageData.unregisteredGateways.length > 0 &&
            (
              <Panel size="huge" title="Unregistered gateways" key={ `org-none` }>
                 <ul className="list">
                  {
                    pageData.unregisteredGateways.map(gateway =>
                      <GatewayListItem
                        key={ `gateway-${gateway.id}` }
                        gateway={ gateway }
                      />
                    )
                  }
                 </ul>
              </Panel>
            )
          }
        </div>
      }
      {
        !pageDataLoading &&
        !pageDataError &&
        pageData.organisations.length === 0 &&
        pageData.unregisteredGateways.length === 0 &&
        <div className="feedback_message  feedback_message--warning">
            {lftext('pages.dashboard.no_gateways')}
        </div>
      }
    </PageLayout>
  );
}

export default Dashboard;
